import React, { Component } from 'react'
import styled from 'styled-components'

import Content from './content'
import Footer from './footer'
import Header from './header'


const ApplicationContainer = styled.div`
width: 100%;
margin: auto;

@media (max-width: 768px) {
  width: 100%;
  height: 100%;
}
`

class ApplicationLayout extends Component {
  render() {
    return (
      <ApplicationContainer>
        <Header/>
        <Content>
          {this.props.children}
        </Content>
        <Footer />
      </ApplicationContainer>
    )
  }
}

export default ApplicationLayout
